import React from 'react';
import {
	Form, Empty, Checkbox, Button, message, Col, Row, Input, Select, DatePicker, Space, Card, Radio, Spin,
	InputNumber, Descriptions, ConfigProvider
} from 'antd';
import { PushpinOutlined, CalendarOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { APIService } from '../../../../services/projectManager/api';
import { CalendarTimeService } from '../../../../services/calendar/calendar.tool.service.js';
import { __waterDocumentSvg } from '../../../../lib/waterMarking.js';
import SelectCricle from './CusComponent.jsx';
import Replacement from './Replacement.jsx'
import 'antd/dist/antd.css';
import './BaseInfo.scss'
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import zhCN from 'antd/es/locale/zh_CN';



class BaseInfo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.data.isEdit,
			loading: false,
			dept: [], //部门
			user: [], //用户
			investment: [], //投顾
			sale: [], //代销
			bank: [], //托管银行
			reclassify: [
				{
					id: "投资管理型",
					name: "投资管理型",
				},
				{
					id: "投资顾问型",
					name: "投资顾问型",
				},
				{
					id: "公开市场资产证券化",
					name: "公开市场资产证券化",
				},
				{
					id: "非公开市场准资产证券化与流动化",
					name: "非公开市场准资产证券化与流动化",
				},
				{
					id: "债权投资",
					name: "债权投资",
				},
				{
					id: "非公开市场金融产品投资",
					name: "非公开市场金融产品投资",
				},
				{
					id: "混合投资",
					name: "混合投资",
				},
				{
					id: "股权信托",
					name: "股权信托",
				},
				{
					id: "企业年金信托",
					name: "企业年金信托",
				},
				{
					id: "土地流转信托",
					name: "土地流转信托",
				}, {
					id: "其他财产权信托",
					name: "其他财产权信托",
				},
				{
					id: "消费信托",
					name: "消费信托",
				}, {
					id: "管理型与结构化",
					name: "管理型与结构化",
				},
				{
					id: "专户投资",
					name: "专户投资",
				}, {
					id: "间接投资",
					name: "间接投资",
				},
				{
					id: "直接债务融资",
					name: "直接债务融资",
				},
				{
					id: "股权投资附加回购",
					name: "股权投资附加回购",
				}, {
					id: "私募股权投资与风险投资",
					name: "私募股权投资与风险投资",
				},
				{
					id: "上市公司定向增发",
					name: "上市公司定向增发",
				},
				{
					id: "纯债务型结构化融资",
					name: "纯债务型结构化融资",
				},
				{
					id: "债务加权益型结构化融资",
					name: "债务加权益型结构化融资",
				},
				{
					id: "可转换或交换债务或权益",
					name: "可转换或交换债务或权益",
				},
				{
					id: "股权投资",
					name: "股权投资",
				},
				{
					id: "股债混合投资",
					name: "股债混合投资",
				},
				{
					id: "现金管理工具",
					name: "现金管理工具",
				},
				{
					id: "短期理财",
					name: "短期理财",
				}, {
					id: "债券型",
					name: "债券型",
				},
				, {
					id: "股票型",
					name: "股票型",
				},
				, {
					id: "标准化产品投资",
					name: "标准化产品投资",
				},
				, {
					id: "非标准化产品投资",
					name: "非标准化产品投资",
				},
			],
			evenyear: false,//控制开放频率的 input
		};

		// this.domRef = null;

		// this.setCallBackRef = element => {
		// 	this.domRef = element
		// }

		// this.formRef = React.createRef();

	}

	componentDidMount() {
		const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
		__waterDocumentSvg({
			container: document.getElementById('ProjectManager-Base'),
			// content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
			content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
			width: '700px',
			height: '550px',
			opacity: '0.1',
			fontSize: '26px',
			zIndex: 1000
		})
		this.initData();
		// this.initPage();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		};
	}

	formatNumber = (num, point = 0) => {
		if (num) {
			num = `${parseFloat(num).toFixed(point)}`
			let num_list = num.split('.')
			if (num_list.length == 2) {
				return `${num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')}.${num_list[1]}`;
			} else {
				return num_list[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
			}
		} else {
			return ''
		}
	};

	initData = () => {
		//获取部门列表信息
		APIService.GetDeptList().then(res => {
			if (res.success) {
				this.setState((prev, props) => {
					return { dept: res.rows }
				})
			} else {
				message.error(`获取用户信息Error:${res.error}`);
			}
		}).catch(err => {
			console.log('获取部门列表信息Error', err)
		})
		// 获取用户信息
		APIService.GetUserList().then(res => {
			if (res.success) {
				this.setState((prev, props) => {
					return { user: res.user_list, investment: res.investment_list, sale: res.sale_list }
				})
			} else {
				message.error(`获取用户信息Error:${res.error}`);
			}
		}).catch(err => {
			console.log('获取用户信息Error', err)
		})
		// 获取托管银行信息
		APIService.GetBankList().then(res => {
			if (res.success) {
				this.setState((prev, props) => {
					return { bank: res.rows }
				})
			} else {
				message.error(`获取用户信息Error:${res.error}`);
			}
		}).catch(err => {
			console.log('获取托管银行信息 Error', err)
		})
	};

	initPage = () => {
		const { formData } = this.props.data;
		console.log('formData', formData, this.props)
		this.formRef.current.setFieldsValue(formData)
	};

	onFinish = (formsValue) => {
		console.log('formsValue', formsValue);
		this.setState((prev, props) => {
			return { loading: true }
		})
		const date_fields = ['f14', 'f15'];
		let values = {};
		Object.keys(formsValue).map(field => {
			if (formsValue[field] != undefined) {
				if (date_fields.includes(field)) {
					values[field] = formsValue[field].format('YYYY-MM-DD')
				} else {
					values[field] = formsValue[field]
				}
			}
		})

		let param = {
			data: JSON.stringify(values),
		};
		APIService.SaveProject(param).then(res => {
			if (res.success) {
				message.success('提交项目管理基本信息成功!');
				if (this.props.data.setRowId) {
					this.props.data.setRowId(res.row_id)
				}
				console.log('提交项目管理基本信息成功 res', res)
			} else {
				message.error(res.error)
			}
			this.setState((prev, props) => {
				return { loading: false }
			})
		}).catch(err => {
			console.log('提交项目管理基本信息 Error', err);
			this.setState((prev, props) => {
				return { loding: false }
			})
		})
	};

	changeBank = (value) => {
		console.log('value', value)
		const { getFieldValue, setFieldsValue } = this.formRef.current;
		const { bank } = this.state;
		let data = bank.filter(row => { return row.id == value })
		if (data.length > 0) {
			setFieldsValue({
				'f52': data[0]['name'], //户名
				'f53': data[0]['acount'], //账号
				'f51': data[0]['open_bank'], //开户银行
			})
		}
	};

	// from置空
	eliminate = (f) => {
		this.props.formRef.current.resetFields([f]);
	}

	render() {
		const { isEdit, formData } = this.props.data;
		const { loading, user, dept, investment, sale, bank, reclassify, evenyear } = this.state;

		console.log(formData, "formData")
		return (
			<div id="ProjectManager-Base">
				<ConfigProvider locale={zhCN}>
					<Spin
						locale={zhCN}
						size="large"
						spinning={loading}
					>
						{/*
				<Form
					ref={this.formRef}
					name='base'
					labelAlign="left"
					layout="inline"
					initialValues={formData}
					onFinish={this.onFinish}
				>
				*/}
						<Form.Item name="_id" hidden={true}><Input /></Form.Item>
						<Descriptions
							bordered
							size="middle"
							style={{ width: '100%' }}
							column={2}
						>
							<Descriptions.Item
								className="label_name"
								label="申请部门"
							>
								<Form.Item
									name="f5"
                                    className='query_cycle'
								>
									<Select
										placeholder={"请选择申请部门"}
										showSearch
										bordered={false}
										disabled={!isEdit}
										allowClear
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										// mode="multiple"
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{
											dept.map(row => (
												<Select.Option
													key={row['id']}
													value={row['name']}
												>
													{row['name']}
												</Select.Option>
											))
										}
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="项目负责人"
							>
								<Form.Item
									name="f6"
								>
									<Select
										placeholder={"请选择项目负责人"}
										showSearch
										disabled={!isEdit}
										bordered={false}
										allowClear
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										// mode="multiple"
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{
											user.map(row => (
												<Select.Option
													key={row['id']}
													value={row['name']}
												>
													{row['name']}
												</Select.Option>
											))
										}
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								span={2}
								label={<span>信托计划名称<font style={{ color: 'red', fontSize: 18 }}>*</font></span>}
							>
								<Form.Item
									name="f7"
									rules={[
										{
											required: true,
											message: '请填写信托计划名称!',
										},
									]}
								>
									<Input disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label={<span>项目编号</span>}
							>
								<Form.Item
									name="f8"
								>
									<Input disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label={<span>三级分类</span>}
							>
								<Form.Item
									name="f186"
                                    className='query_cycle'
								>
									<Select
										placeholder={"请选择三级分类"}
										showSearch
										disabled={!isEdit}
										bordered={false}
										allowClear
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										// mode="multiple"
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{
											reclassify.map(row => (
												<Select.Option
													key={row['id']}
													value={row['name']}
												>
													{row['name']}
												</Select.Option>
											))
										}
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="电话/传真"
							>
								<Form.Item
									name="f9"
								>
									<Input disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="信托计划类别"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f10"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="集合">集合</Radio.Button>
											<Radio.Button value="单一">单一</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f10"}/>
									}
								</div>

							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="成立日期"
							>
								<Form.Item
									name="f11"
                                    className='query_cycle'
								>
									<DatePicker
										disabled={!isEdit}
										locale={locale}
										bordered={false}
										style={{ width: '100%' }}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									/>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="终止日期"
							>
								<Form.Item
									name="f12"
                                    className='query_cycle'
								>
									<DatePicker
										disabled={!isEdit}
										locale={locale}
										bordered={false}
										style={{ width: '100%' }}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									/>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="信托本金总额"
							>
								<Form.Item
									name="f13"

								>
									<InputNumber
										style={{ width: '100%' }}
										disabled={!isEdit}
										bordered={false}
										formatter={value => `${this.formatNumber(value)}`}
									/>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="是否结构化分级"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f14"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f14"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="优先信托本金额"
							>
								<Form.Item
									name="f15"

								>
									<InputNumber
										style={{ width: '100%' }}
										disabled={!isEdit}
										bordered={false}
										formatter={value => `${this.formatNumber(value)}`}
									/>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="是否有归集账户"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f16"

									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f16"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="是否有投资顾问"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f17"
                                        className='query_cycle'
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f17"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								// label="投资顾问名称"
								className="label_name"
								label={<span>投资顾问名称<font style={{ color: 'red', fontSize: 18 }}>*</font></span>}
							>
								<Form.Item
									name="f18"
									rules={[
										{
											required: true,
											message: '请填写投资顾问名称!',
										},
									]}
								>
									<Select
										placeholder={"请选择投资顾问名称"}
										showSearch
										disabled={!isEdit}
										bordered={false}
										allowClear
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										// mode="multiple"
										// maxTagCount={1}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{
											investment.map(row => (
												<Select.Option
													key={row['id']}
													value={row['name']}
												>
													{row['name']}
												</Select.Option>
											))
										}
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="产品策略类型"
							>
								<Form.Item
									name="f19"
                                    className='query_cycle'
								>
									<Select
										placeholder={"请选择产品策略类型"}
										disabled={!isEdit}
										showSearch
										bordered={false}
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{/* <Select.Option value="权益性">权益性</Select.Option> */}
										<Select.Option value="权益性">权益型</Select.Option>
										<Select.Option value="混合型">混合型</Select.Option>
										<Select.Option value="固定收益型">固定收益型</Select.Option>
										<Select.Option value="衍生品型">衍生品型</Select.Option>
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="信托交易结构"
							>
								<Form.Item
									name="f20"
                                    className='query_cycle'
								>
									<Select
										disabled={!isEdit}
										bordered={false}
										placeholder={"请选择信托交易结构"}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										<Select.Option value="底层在信托端">底层在信托端</Select.Option>
										<Select.Option value="TOF或TOT">TOF或TOT</Select.Option>
										<Select.Option value="其他">其他</Select.Option>
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="TOF类业务结构"
								span={2}
							>
								<Form.Item
									name="f21"
                                    className='query_cycle'
								>
									<Select
										disabled={!isEdit}
										bordered={false}
										placeholder={"请选择TOF类业务结构"}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										<Select.Option value="一一对应">一一对应</Select.Option>
										<Select.Option value="一对多">一对多</Select.Option>
										<Select.Option value="多对一">多对一</Select.Option>
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="交易系统(本公司系统)"
								span={1}
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f196"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f196"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="确认事项"
								span={1}
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f197"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="资管系统">资管系统</Radio.Button>
											<Radio.Button value="衡泰系统">衡泰系统</Radio.Button>
										</Radio.Group>

									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f197"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="交易系统(外部PB)"
								span={1}
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f198"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="是">是</Radio.Button>
											<Radio.Button value="否">否</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f198"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="确认事项"
								span={1}
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f199"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="可自动审批">可自动审批</Radio.Button>
											<Radio.Button value="外部系统可实现投资限制条款">外部系统可实现投资限制条款</Radio.Button>
										</Radio.Group>

									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f199"}/>
									}
								</div>
							</Descriptions.Item>

							<Descriptions.Item
								className="label_name"
								label="电子投资建议约定"
								span={2}
							>
								<Form.Item
									name="f23"
                                    className='query_cycle'
								>
									<Select
										disabled={!isEdit}
										bordered={false}
										placeholder={"请选择电子投资建议约定"}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										<Select.Option value="信托合同中明确">信托合同中明确</Select.Option>
										<Select.Option value="投顾协议中明确">投顾协议中明确</Select.Option>
										<Select.Option value="未作约定">未作约定</Select.Option>
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								className="label_name"
								label="投资建议发起人"
							>
								<div className="highlight">
									<Form.Item
										name="f25"

									>
										<Select
											allowClear
											mode="multiple"
											disabled={!isEdit}
											bordered={false}
											getPopupContainer={triggerNode => triggerNode.parentNode}
											placeholder={"请选择投资建议发起人"}
										>
											<Select.Option value="投顾授权投资经理">投顾授权投资经理</Select.Option>
											<Select.Option value="委托人指令授权人">委托人指令授权人</Select.Option>
											<Select.Option value="委托人">委托人</Select.Option>
											<Select.Option value="我司投资经理">我司投资经理</Select.Option>
										</Select>
									</Form.Item>
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="开放/封闭式产品"
								className="label_name"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f26"

									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="开放">开放</Radio.Button>
											<Radio.Button value="封闭">封闭</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit &&<Replacement formRef={this.props.formRef} subscript={"f26"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="开放频率"
								className="label_name"
							>
								<Form.Item
									name="f27"
									shouldUpdate
                                    className='query_cycle'
								>
									<SelectCricle
										placeholder={"请选择开放频率"}
										bordered={false}
										disabled={!isEdit}
									/>
									{/*
								<Select
									allowClear
									// mode="multiple"
									disabled={!isEdit}
									bordered={false}
									getPopupContainer={triggerNode => triggerNode.parentNode}
									placeholder={"请选择开放频率"}
								>
									<Select.Option value="每日">每日</Select.Option>
									<Select.Option value="每周">每周</Select.Option>
									<Select.Option value="每月">每月</Select.Option>
									<Select.Option value="每季度">每季度</Select.Option>
									<Select.Option value="每半年">每半年</Select.Option>
									<Select.Option value="每年">每年</Select.Option>
									<Select.Option value="每_个月">每_个月</Select.Option>
									<Select.Option value="其他">其他</Select.Option>
								</Select>
								*/}

								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="开放规则描述"
								span={2}
								className="label_name textarea"
							>
								<Form.Item
									name="f28"

								>
									<Input.TextArea disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="投资标的开放类型(TOF类)"
								className="label_name"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f29"

									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="开放">开放</Radio.Button>
											<Radio.Button value="封闭">封闭</Radio.Button>
										</Radio.Group>

									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f29"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="投资标的开放频率"
								className="label_name"
							>
								<Form.Item
									name="f30"
                                    className='query_cycle'
								>
									<SelectCricle
										placeholder={"请选择开放频率"}
										bordered={false}
										disabled={!isEdit}
									/>
									{/* <Select
										allowClear
										// mode="multiple"
										disabled={!isEdit}
										bordered={false}
										getPopupContainer={triggerNode => triggerNode.parentNode}
										placeholder={"请选择投资标的开放频率"}
									>
										<Select.Option value="每日">每日</Select.Option>
										<Select.Option value="每周">每周</Select.Option>
										<Select.Option value="每月">每月</Select.Option>
										<Select.Option value="每季度">每季度</Select.Option>
										<Select.Option value="每半年">每半年</Select.Option>
										<Select.Option value="每年">每年</Select.Option>
										<Select.Option value="每_个月">每_个月</Select.Option>
										<Select.Option value="其他">其他</Select.Option>
									</Select> */}
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="投资标的开放规则描述"
								className="label_name textarea"
								span={2}
							>
								<Form.Item
									name="f31"

								>
									<Input.TextArea disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="开放日运营时效（T+N）"
								span={2}
								className="label_name"
							>
								<Row gutter={[5, 5]}>
									<Col span={8}>
										<Form.Item
											name="f34"
											label="估值出具"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
									<Col span={8}>
										<Form.Item
											name="f33"
											label="TA清算"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
									<Col span={8}>
										<Form.Item
											name="f35"
											label="分配清算"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
								</Row>
							</Descriptions.Item>
							<Descriptions.Item
								label="信托专户/托管户"
								span={2}
								className="label_name"
							>
								<Row gutter={[5, 5]}>
									<Col span={12}>
										<Form.Item
											name="f36"
											label="托管银行"
                                            className='query_cycle'
										>
											<Select
												showSearch
												disabled={!isEdit}
												bordered={false}
												allowClear
												optionFilterProp="label"
												filterOption={(input, option) =>
													option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
												}
												onChange={this.changeBank}
												placeholder={"请选择托管银行"}
												// mode="multiple"
												getPopupContainer={triggerNode => triggerNode.parentNode}
											>
												{
													bank.map(row => (
														<Select.Option
															key={row['id']}
															value={row['trustee_bank']}
														>
															{row['trustee_bank']}
														</Select.Option>
													))
												}
											</Select>
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											name="f38"
											label="户名"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={[5, 5]}>
									<Col span={12}>
										<Form.Item
											name="f37"
											label="开户银行"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
									<Col span={12}>
										<Form.Item
											name="f39"
											label="账号"
										>
											<Input disabled={!isEdit} bordered={false} />
										</Form.Item>
									</Col>
								</Row>
							</Descriptions.Item>
							<Descriptions.Item
								label="销售渠道"
								className="label_name"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f40"
									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="直销">直销</Radio.Button>
											<Radio.Button value="代销">代销</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f40"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="是否线下认购"
								className="label_name"
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f42"

									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button value="有">有</Radio.Button>
											<Radio.Button value="无">无</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f42"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="代销机构"
								span={2}
							>
								<Form.Item
									name="f41"
                                    className='query_cycle'
								>
									<Select
										showSearch
										disabled={!isEdit}
										allowClear
										bordered={false}
										optionFilterProp="label"
										filterOption={(input, option) =>
											option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
										}
										mode="multiple"
										placeholder={"请选择代销机构"}
										maxTagCount={1}
										getPopupContainer={triggerNode => triggerNode.parentNode}
									>
										{
											sale.map(row => (
												<Select.Option
													key={row['id']}
													value={row['name']}
												>
													{row['name']}
												</Select.Option>
											))
										}
									</Select>
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="投资者计数规则"
								className="label_name"
								span={1}
							>
								<div style={{ display: 'flex' }}>
									<Form.Item
										name="f43"

									>
										<Radio.Group buttonStyle="solid" disabled={!isEdit}>
											<Radio.Button style={{display:'block'}} value="累计认购300万以下自然人数不超过50人">累计认购300万以下自然人数不超过50人</Radio.Button>
											<Radio.Button style={{display:'block'}} value="信托计划认购人数不超过200人">信托计划认购人数不超过200人</Radio.Button>
										</Radio.Group>
									</Form.Item>
									{
										isEdit && <Replacement formRef={this.props.formRef} subscript={"f43"}/>
									}
								</div>
							</Descriptions.Item>
							<Descriptions.Item
								label="备注说明"
								className="label_name textarea"
								span={1}
							>
								<Form.Item
									name="f44"

								>
									<Input.TextArea disabled={!isEdit} bordered={false} />
								</Form.Item>
							</Descriptions.Item>
							<Descriptions.Item
								label="信托文件"
								className="label_name"
								span={2}
							>
								<div className="highlight" id="instrument">
									<Form.Item
										name="f45"

									>
										<Select
											disabled={!isEdit}
											allowClear
											mode="multiple"
											bordered={false}
											getPopupContainer={triggerNode => triggerNode.parentNode}
											placeholder={"请选择信托文件"}
										>
											{
												['信托合同', '保管协议', '经纪服务协议', '期货操作备忘', '投顾协议', '销售协议',
													'成立公告（托管行）', '认购单', '其他协议（自定义）'].map(val => (
														<Select.Option key={val} value={val}>{val}</Select.Option>
													))
											}
										</Select>
									</Form.Item>
								</div>
							</Descriptions.Item>


						</Descriptions>
						{/*
				</Form>
				*/}
					</Spin>
				</ConfigProvider>

			</div>
		)
	}
}

export default BaseInfo;


// WEBPACK FOOTER //
// app/components/customPage/project-manager/Pages/BaseInfo.jsx